import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: null,
};

const instrumentsSlice = createSlice({
  name: "instruments",
  initialState,
  reducers: {
    fetchInstrumentsStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchInstrumentsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchInstrumentsFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetInstrumentsState(state) {
      state.data = [];
      state.isLoading = false;
      state.error = null;
      state.success = null;
    },
    resetInstrumentsStatus(state) {
      state.isLoading = false;
      state.error = null;
      state.success = null;
    },
    // DELETE
    bulkDeleteInstrumentsRequest(state) {
      state.isLoading = true;
      state.error = null;
    },
    bulkDeleteInstrumentsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    bulkDeleteInstrumentsFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchInstrumentsStart,
  fetchInstrumentsSuccess,
  fetchInstrumentsFailure,
  resetInstrumentsState,
  resetInstrumentsStatus,
  bulkDeleteInstrumentsRequest,
  bulkDeleteInstrumentsSuccess,
  bulkDeleteInstrumentsFailure,
} = instrumentsSlice.actions;
export default instrumentsSlice.reducer;
